// extracted by mini-css-extract-plugin
export default {"loader":"ClaimTraitWaitingConfirmation_loader__Y+4Ol","container":"ClaimTraitWaitingConfirmation_container__q0NJ-","loading":"ClaimTraitWaitingConfirmation_loading__mptC+"};